import { type AnyObjectSchema } from 'yup';

export type FormConfig = {
    inputs?: Record<
        string,
        {
            // Used by templates that render this input, relative to a namespace the template picks.
            // See application_questions_form.html.
            localeKey?: string;
            // The label the schema-driven error list shows for this path. A full locale key, because
            // the labels on one step can come from more than one namespace.
            //
            // A step with a `validationSchema` needs one of these for every path its schema can fail
            // on. A path with no label falls back to showing the raw path. See getSchemaFieldLabel in
            // edit_career_profile_dir.js.
            errorLabelKey?: string;
            maxCharLength?: number;
            required: boolean;
            // The `data-field-path` marker this schema path belongs to, when it is not the path
            // itself. One control can set several paths: the location control on basic_info writes
            // both `place_id` and `place_details`, and carries the `place_id` marker.
            //
            // Paths that resolve to the same marker collapse to one entry in the error list, and that
            // entry scrolls to the marker.
            fieldPath?: string;
        }
    >;
    stepName: string;
    requiresVisit?: boolean;
    // A step the user never has to answer. It still carries a `validationSchema`, because an
    // optional step can hold a conditionally required input: demographics asks for a written answer
    // once the user selects "other" for race.
    //
    // getFormsCompletePercent reads this. Without it that function treats every step that has a
    // schema as required, and an optional step would join the denominator and inflate the progress
    // the user sees. See FormCompletionHelper.
    optional?: boolean;
    validationSchema?: AnyObjectSchema;
};

// Which set of forms a user is filling out. The same forms back both contexts, so this has to be
// passed in explicitly. See getFormConfigsForContext for the step lists each context uses.
export enum CareerProfileFormContext {
    // /settings/application
    application = 'application',
    // /settings/my-profile
    studentProfile = 'student_profile',
}
